// src/store/common/profile.js
import axiosInstance from "../../axios";

// Action Types
export const PROFILE_REQUEST = 'PROFILE_REQUEST';
export const PROFILE_SUCCESS = 'PROFILE_SUCCESS';
export const PROFILE_FAILURE = 'PROFILE_FAILURE';
export const PROFILE_UPDATE_REQUEST = 'PROFILE_UPDATE_REQUEST';
export const PROFILE_UPDATE_SUCCESS = 'PROFILE_UPDATE_SUCCESS';
export const PROFILE_UPDATE_FAILURE = 'PROFILE_UPDATE_FAILURE';

// Action Creators
export const profileRequest = () => ({
    type: PROFILE_REQUEST,
});

export const profileSuccess = (profile) => ({
    type: PROFILE_SUCCESS,
    payload: profile,
});

export const profileFailure = (error) => ({
    type: PROFILE_FAILURE,
    payload: error,
});

export const profileUpdateRequest = () => ({
    type: PROFILE_UPDATE_REQUEST,
});

export const profileUpdateSuccess = (profile) => ({
    type: PROFILE_UPDATE_SUCCESS,
    payload: profile,
});

export const profileUpdateFailure = (error) => ({
    type: PROFILE_UPDATE_FAILURE,
    payload: error,
});

// Thunk Actions
export const fetchUserProfile = () => async (dispatch) => {
    try {
        dispatch(profileRequest());
        const response = await axiosInstance.get('user/profile');
        console.log("PROFILE RESPONSE", response);

        const profileData = response.data.data;
        dispatch(profileSuccess(profileData));
    } catch (error) {
        console.log(error);
        let errorMessage = 'Failed to fetch user profile';
        if (error.message) {
            errorMessage = error.message;
        }
        dispatch(profileFailure(errorMessage));
    }
};

export const updateUserProfile = (profileData) => async (dispatch) => {
    try {
        dispatch(profileUpdateRequest());
        const response = await axiosInstance.post('user/update', profileData);
        console.log("UPDATE PROFILE RESPONSE", response);

        const updatedProfile = response.data.data;
        dispatch(profileUpdateSuccess(updatedProfile));
        return Promise.resolve(updatedProfile);
    } catch (error) {
        console.log(error);
        let errorMessage = 'Failed to update user profile';
        if (error.message) {
            errorMessage = error.message;
        }
        dispatch(profileUpdateFailure(errorMessage));
        return Promise.reject(errorMessage);
    }
};

// Initial State
const initialState = {
    loading: false,
    updating: false,
    profile: null,
    error: null
};

// Reducer
const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case PROFILE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                profile: action.payload,
                error: null
            };

        case PROFILE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case PROFILE_UPDATE_REQUEST:
            return {
                ...state,
                updating: true,
                error: null
            };

        case PROFILE_UPDATE_SUCCESS:
            return {
                ...state,
                updating: false,
                profile: action.payload,
                error: null
            };

        case PROFILE_UPDATE_FAILURE:
            return {
                ...state,
                updating: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default profileReducer;